import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../core/auth.service";
import { Router } from '@angular/router';

@Component({
  selector: "app-page-management",
  templateUrl: "./page-management.component.html",
  styleUrls: ["./page-management.component.scss"]
})

export class PageManagementComponent implements OnInit {
  exeFunctionOnlyOnce = true;
  
  constructor( public auth: AuthService,
               private router: Router) { 

  }

  ngOnInit() {
  }

  userControle(user) {
    if (this.exeFunctionOnlyOnce) {
        if (user.role === undefined) {
          this.router.navigate(['/home']);
          // this.auth.deleteUser(user);
        } else {
          this.router.navigate(['/profile']);
        }
        this.exeFunctionOnlyOnce = false ;
    }
  }
}
